import * as React from "react"
import {
  Modal,
  StyledModal,
  StyledModalHeader,
  StyledModalBody,
  StyledModalActions,
  Button,
  Text,
  ModalCard,
} from "gatsby-interface"
import { siteTransfer as text, ui as uiText } from "@modules/locales/default.js"
import { FormattedMessage, commonMessageTags } from "@modules/locales"

export type TransferSiteResendModalprops = {
  isOpen: boolean
  onDismiss: () => void
  onConfirm: () => void
  loading: boolean
  error?: JSX.Element | null
  sentTo?: string | null
}

export function TransferSiteResendModal({
  isOpen,
  onDismiss,
  onConfirm,
  loading,
  error,
  sentTo,
}: TransferSiteResendModalprops) {
  return (
    <Modal isOpen={isOpen} aria-label={``} onDismiss={onDismiss}>
      <ModalCard>
        <StyledModal variant="ACTION">
          <StyledModalHeader onCloseButtonClick={onDismiss}>
            {text.headers.resendEmail}
          </StyledModalHeader>
          <StyledModalBody>
            <Text>
              <FormattedMessage<"email", "strong">
                values={{ email: sentTo || `` }}
                message={text.messages.areYourSureYouWantToResendEmail}
                tags={commonMessageTags}
              />
            </Text>

            {error}

            <StyledModalActions>
              <Button
                variant="SECONDARY"
                tone="NEUTRAL"
                type="button"
                onClick={onDismiss}
              >
                {uiText.actions.cancel}
              </Button>
              <Button
                variant="PRIMARY"
                type="submit"
                data-cy="revoke-invite-cta"
                onClick={onConfirm}
                loading={loading}
                disabled={loading}
                loadingLabel={text.labels.resending}
              >
                {text.labels.resendEmail}
              </Button>
            </StyledModalActions>
          </StyledModalBody>
        </StyledModal>
      </ModalCard>
    </Modal>
  )
}
